import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { ApiResponse, PaginatedParams, PaginatedResponse } from "@/lib/api/types";
import { buildPaginatedUrl } from "@/lib/api/utils";

const BASE = "/users";

export const usersApi = {
  getMe: () => apiGet<{ user: Record<string, unknown> }>(`${BASE}/me`),

  getProfile: (userId: string) => apiGet<{ user: Record<string, unknown> }>(`${BASE}/${userId}`),

  updateProfile: (data: Record<string, unknown>) =>
    apiPut<{ user: Record<string, unknown> }>(`${BASE}/me`, data),

  addExperience: (data: Record<string, unknown>) =>
    apiPost<{ experience: Record<string, unknown> }>(`${BASE}/me/experiences`, data),

  updateExperience: (id: string, data: Record<string, unknown>) =>
    apiPut<{ experience: Record<string, unknown> }>(`${BASE}/me/experiences/${id}`, data),

  deleteExperience: (id: string) => apiDelete<{ message: string }>(`${BASE}/me/experiences/${id}`),

  addEducation: (data: Record<string, unknown>) =>
    apiPost<{ education: Record<string, unknown> }>(`${BASE}/me/education`, data),

  deleteEducation: (id: string) => apiDelete<{ message: string }>(`${BASE}/me/education/${id}`),

  addCertification: (data: Record<string, unknown>) =>
    apiPost<{ certification: Record<string, unknown> }>(`${BASE}/me/certifications`, data),

  deleteCertification: (id: string) => apiDelete<{ message: string }>(`${BASE}/me/certifications/${id}`),

  list: (params?: PaginatedParams) => {
    return apiGet<{ users: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      buildPaginatedUrl(`/admin/users`, params)
    );
  },

  updateRole: (userId: string, role: string) =>
    apiPut<{ user: Record<string, unknown> }>(`/admin/users/${userId}/role`, { role }),

  suspend: (userId: string) => apiPut<{ message: string }>(`/admin/users/${userId}/suspend`),

  activate: (userId: string) => apiPut<{ message: string }>(`/admin/users/${userId}/restore`),

  delete: (userId: string) => apiDelete<{ message: string }>(`/admin/users/${userId}`),
};
